import { ProposalSkeleton } from 'modules/new-business/components/molecules/proposal-skeleton/ProposalSkeleton';
import { PropsWithChildren } from 'react';

interface ProposalSkeletonLoaderProps {
  loading: boolean;
}

export const ProposalSkeletonLoader = ({
  loading,
  children
}: PropsWithChildren<ProposalSkeletonLoaderProps>) => {
  return <>{loading ? <ProposalSkeleton /> : children}</>;
};
